module.exports = __webpack_public_path__ + "media/MonsieurMelody.7f05175d.mp3";